<template>
    <router-view></router-view>
</template>
<script>
import User from '../../shared/models/User';
export default {
    mounted(){
        User.listMenuByUsers({ ModuleCode: '02' }).then(res => {
            this.$store.commit('setMenu', res.Menus);
        });
    },
    destroyed(){
        this.$store.commit('setMenu', []);
    }
}
</script>